import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useBuyerAuth } from '../contexts/BuyerAuthContext';

export const PortalLogin: React.FC = () => {
  const { buyer, loading, requestLink } = useBuyerAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  if (!loading && buyer) {
    navigate('/portal', { replace: true });
    return null;
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitting(true);
    await requestLink(email.trim());
    setSubmitting(false);
    setSent(true);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-light-bg px-6">
      <div className="w-full max-w-sm text-center">
        <Link to="/" className="font-display text-xl tracking-wide text-light-text-primary">Lot 20</Link>

        {sent ? (
          <div className="mt-10">
            <p className="text-[11px] uppercase tracking-eyebrow text-light-text-tertiary mb-3">Check your email</p>
            <h1 className="font-display text-2xl text-light-text-primary mb-4">Sign-in link sent</h1>
            <p className="text-sm text-light-text-secondary leading-relaxed">
              If <strong className="text-light-text-primary">{email}</strong> is on file as a buyer, a private sign-in link is on its way. It expires in 15 minutes.
            </p>
            <button
              onClick={() => setSent(false)}
              className="mt-8 text-xs text-light-text-tertiary hover:text-light-text-primary transition-colors underline underline-offset-2"
            >
              Use a different email
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="mt-10 text-left">
            <p className="text-[11px] uppercase tracking-eyebrow text-light-text-tertiary mb-3 text-center">Buyer Portal</p>
            <h1 className="font-display text-2xl text-light-text-primary mb-3 text-center">Sign in</h1>
            <p className="text-sm text-light-text-secondary text-center mb-8 leading-relaxed">
              Enter the email address you use with Lot 20 and we'll send you a private sign-in link.
            </p>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="you@company.com"
              autoFocus
              required
              className="w-full px-4 py-3 border border-light-border rounded-lg bg-white text-light-text-primary placeholder-light-text-tertiary focus:outline-none focus:ring-2 focus:ring-brand-accent/30 focus:border-brand-accent/50 transition-all"
            />
            <button
              type="submit"
              disabled={submitting || !email.trim()}
              className="w-full mt-4 py-3 bg-brand-accent text-white rounded-lg font-medium hover:bg-brand-accent-dark transition-colors disabled:opacity-50"
            >
              {submitting ? 'Sending...' : 'Send sign-in link'}
            </button>
          </form>
        )}

        <p className="mt-12 text-xs text-light-text-tertiary">
          Not a buyer yet? <a href="/contact" className="text-light-text-primary hover:text-brand-accent transition-colors">Get in touch</a>
        </p>
      </div>
    </div>
  );
};
